(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        if (this.announcementBar) this.announcementBar.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.announcementBar) {
        document.documentElement.style.setProperty(
          '--announcement-height',
          `${this.announcementBar.offsetHeight}px`
        );
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-sticky', 'animate');
        this.announcementBar.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar) {
        this.announcementBar.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oribio-before-after"] && !Shopify.designMode) return;
  try {
    
  class OribioCompare extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.oribio-ba__range');
      if (!this.range) return;
      this.onInput = this.onInput.bind(this);
      this.range.addEventListener('input', this.onInput);
      this.onInput();
    }
    onInput() {
      this.style.setProperty('--pos', this.range.value + '%');
    }
    disconnectedCallback() {
      if (this.range) this.range.removeEventListener('input', this.onInput);
    }
  }
  if (!customElements.get('oribio-compare')) {
    customElements.define('oribio-compare', OribioCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oribio-welcome-popup"] && !Shopify.designMode) return;
  try {
    
    class OribioWelcome extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.key || 'oribio-welcome';
        this.delay = parseInt(this.dataset.delay || '1200', 10);
        this._onKey = this._onKey.bind(this);
        this.addEventListener('click', (e) => {
          if (e.target === this) return this.dismiss();
          if (e.target.closest('[data-close]')) { e.preventDefault(); return this.dismiss(); }
          if (e.target.closest('[data-pick]')) { this.remember(); }
        });
        if (this.shouldShow()) {
          this.timer = setTimeout(() => this.open(), this.delay);
        }
      }
      shouldShow() {
        try { return !localStorage.getItem(this.key); } catch (e) { return false; }
      }
      remember() {
        try { localStorage.setItem(this.key, '1'); } catch (e) {}
      }
      open() {
        this.hidden = false;
        this._prevFocus = document.activeElement;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this._onKey);
        const focusable = this.querySelector('a[href], button, input');
        if (focusable) focusable.focus();
      }
      dismiss() {
        this.remember();
        this.hidden = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this._onKey);
        if (this.timer) clearTimeout(this.timer);
        if (this._prevFocus && this._prevFocus.focus) this._prevFocus.focus();
      }
      _onKey(e) {
        if (e.key === 'Escape') return this.dismiss();
        if (e.key !== 'Tab') return;
        const f = Array.from(this.querySelectorAll('a[href], button, input')).filter((el) => !el.disabled && el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0];
        const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (!customElements.get('oribio-welcome')) {
      customElements.define('oribio-welcome', OribioWelcome);
    }
  
  } catch(e) { console.error(e); }
})();
})();
